import { StatusBadge } from '@/components/StatusBadge'
import { WordJourneyPanel } from '@/components/vocabulary/WordJourneyPanel'
import { ReviewHistoryTimeline } from '@/components/vocabulary/ReviewHistoryTimeline'
import type { UserWordDetail } from '@/types/user'

interface WordLearningSectionProps {
  word: UserWordDetail
}

export function WordLearningSection({ word }: WordLearningSectionProps) {
  return (
    <section className="mb-6 space-y-4" data-testid="word-learning-section">
      <div className="rounded-xl border bg-card p-4">
        <h2 className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          Learning
        </h2>
        <div className="mb-4 flex flex-wrap items-center gap-2">
          <StatusBadge status={word.status} />
          {word.nextReviewAt && (
            <span className="text-sm text-muted-foreground">
              Next review{' '}
              <span className="font-medium text-foreground">
                {new Date(word.nextReviewAt).toLocaleDateString()}
              </span>
            </span>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {[
            { label: 'Reviews', value: word.reviewCount },
            { label: 'Correct', value: word.successCount },
            { label: 'Interval', value: `${word.intervalDays}d` },
            {
              label: 'Due',
              value: word.nextReviewAt
                ? new Date(word.nextReviewAt).toLocaleDateString()
                : '—',
            },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-border/60 bg-muted/20 px-3 py-2 text-center"
            >
              <p className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
                {item.label}
              </p>
              <p className="mt-0.5 text-base font-semibold tabular-nums">{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <WordJourneyPanel userWordId={word.id} defaultCollapsed />
      <ReviewHistoryTimeline userWordId={word.id} />
    </section>
  )
}
